import { RegisterService } from './../../../../services/cms/register.service';
//Angular
import { Component, OnInit, ViewContainerRef, ChangeDetectionStrategy, ViewEncapsulation, Compiler, Inject, Renderer } from "@angular/core";
import { Router, NavigationExtras, ActivatedRoute } from "@angular/router";

//Services
import { ComponentHelperService } from "./../../../../services/core/component-helper.service";
import { ShoppingCartService } from "./../../../../services/inventory/shopping-cart.service";
import { LanguageService } from "./../../../../services/cms/language.service";
import { AuthService } from "./../../../../services/core/auth.service";
import { CmsComponentService } from "./../../../../services/cms/cms-component.service";
import { RoutesService } from "./../../../../services/core/routes.service";
import { SeoService } from "./../../../../services/core/seo.service";
import { TranslateService } from '@ngx-translate/core';
import { BootboxService } from './../../../../services/core/bootbox.service';
import { ScriptService } from "./../../../../services/cms/script.service";
import { BreadcrumbsService } from '../../../../services/cms/breadcrumbs.service';

//Models
import { SeoViewModel } from "./../../../../models/core/seo";
import { CartInfo } from "./../../../../models/core/cart";
import { CartShipmentModel } from "./../../../../models/core/cart";
import { CartPaymentModel } from "./../../../../models/core/cart";
import { UserLogin } from "./../../../../models/cms/user-login";
import { Company } from "./../../../../models/core/company";
import { Breadcrumbs } from '../../../../models/cms/breadcrumbs';

import { Subscription } from 'rxjs/Subscription';
import { CustomersCanvasService } from '../../../../services/inventory/customerscanvas.service';
import { CookieService } from '../../../../services/core/cookie';
import { DOCUMENT } from '@angular/platform-browser';

@Component({
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.Emulated,
    template: ""
})

export class CartComponent implements OnInit {
    constructor
        (
            private _compiler: Compiler,
            private componentHelper: ComponentHelperService,
            private _elementRef: ViewContainerRef,
            private route: ActivatedRoute,
            private cmsComponentService: CmsComponentService,
            @Inject('isBrowser') private isBrowser: boolean,
            private seo: SeoService,
            private renderer: Renderer,
            @Inject(DOCUMENT) private document: any,
            private scriptService: ScriptService
        ) { }

    subManager = new Subscription();

    ngOnInit() {
        var isChangeShipment = false;
        let paramsSub = this.route.queryParams.subscribe(params => {
            var isChangeShipmentParam = params['isChangeShipment'];
            if (isChangeShipmentParam != undefined) {
                isChangeShipment = isChangeShipmentParam;
            }
        });
        this.subManager.add(paramsSub);
        let header: any;
        let headDataSub = this.cmsComponentService.getHeaderData().subscribe(result => {
            header = result;
            let SideMenuData = this.cmsComponentService.getSideMenuData().subscribe(result1 => {
                if (result1.Categories) {
                    header.Categories = result1.Categories;

                }
            });
            this.subManager.add(SideMenuData);
        });
        this.subManager.add(headDataSub);
        let cartDataSub = this.cmsComponentService.getShoppingCartData().subscribe(result => {
            if (result.SeoInformation) {
                result.SeoInformation.ShortDescription = result.ShortDescription ? result.ShortDescription : '';
                result.SeoInformation.LongDescription = result.LongDescription ? result.LongDescription : '';
            }

            if (this.isBrowser) {
                //Creating subcomponent whith the selected template to inject
                let subComponent = this.createSubComponent(result, header, isChangeShipment);

                //injecting created component (OK)
                this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);
            }
            else {
                let scriptId = this.scriptService.getSystemPageRowId_OrderId(this.scriptService.cartId, result.ShoppingCart.CartID);

                //-- Get head and body scripts
                this.scriptService.setupExternalScripts(result, this.scriptService.typeSystemPage, scriptId);

                //-- Setting SEO data for server side rendering, so it is visible for indexers and crawlers
                this.seo.setSeoMetaData(this.document, this.renderer, result.SeoInformation)
                this.seo.generateSeoDomServerSide(this.document, this.renderer, result.SeoInformation);
            }
        });

        this.subManager.add(cartDataSub);
    }

    ngOnDestroy() {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    }

    private createSubComponent(shoppingCartData: any, header: any, isChangeShipment: any) {
        @Component({
            template: shoppingCartData.TemplateHtml
        })

        class ChildComponent implements OnInit {
            constructor
                (
                    private router: Router,
                    private shoppingCartService: ShoppingCartService,
                    private languageService: LanguageService,
                    private authService: AuthService,
                    private routesService: RoutesService,
                    private seoService: SeoService,
                    private translate: TranslateService,
                    private bootboxService: BootboxService,
                    @Inject('isBrowser') private isBrowser: boolean,
                    private _elementRef: ViewContainerRef,
                    private scriptService: ScriptService,
                    private breadcrumbsService: BreadcrumbsService,
                    private registerService: RegisterService,
                    public canvasService: CustomersCanvasService,
                    @Inject('CookieService') private cookie: CookieService
                ) {
                //check if modal is opened or not, so we can stick or unstick quoting div (if it is stick and modal is opened, there is a layout error, so we need to unstick it)
                const canvasSub = canvasService.isCanvasModalOpened$
                    .subscribe(
                        isModalOpened => {
                            if (isModalOpened == false) {
                                $('html').css("overflow", "visible");
                            }
                            else {
                                // before open of canvas editor, we scroll to the top and set overflow to hidden because of problem with sticky plugin
                                window.scrollTo(0, 0);
                                $('html').css("overflow", "hidden");
                            }
                        });
                // after canvas product design is aproved from a child component (canvas-widget.component.ts), we want to add a product in a cart
                const canvasEditedSub = canvasService.isCanvasProductDesignApproved$
                    .subscribe(
                        isDesignApproved => {
                            if (isDesignApproved) {
                                $('#customerCanvasModal').modal('hide');
                                $('html').css("overflow", "visible");

                                // set for product info that it is edited in canvas, so we know if we should pass canvas data to the server or not
                                shoppingCartService.setIfProductIsCanvasEdited(true);

                                // get row id of edited element
                                let productId = this.clickedProductId;
                                // get data which we get from customer canvas and saved in a cart service
                                let canvasData = shoppingCartService.getCustomizationCanvasData();
                                canvasData["RowIdPrev"] = productId;

                                if (canvasData && productId && canvasData.status == "success") {
                                    let updateCanvas = canvasService.updatePrevCanvasInfo(canvasData).subscribe(x => {
                                        let objectToUpdateStateId = this.carrello.Products.find(obj => {
                                            return obj.Id === productId;
                                        })
                                        objectToUpdateStateId.CanvasStateId = canvasData.stateId;
                                    });

                                    this.subManager.add(updateCanvas);
                                }
                                // reset editor view
                                shoppingCartService.resetCanvasData();
                            }
                        });

                this.subManager.add(canvasSub);
                this.subManager.add(canvasEditedSub);
            }

            // model = {
            //     selectedPayment: new CartPaymentModel(),
            //     selectedShipment: new CartShipmentModel(),
            //     selectedPickUp: new CartShipmentModel(),
            //     selectedDelivery: new CartShipmentModel()
            // }

            private pageIsInit: boolean = false;
            private pageIsInitAfter: boolean = false;
            shipmentToShow: CartShipmentModel[];
            areaStatus: any;
            carrello: CartInfo = shoppingCartData.ShoppingCart;
            items = this.carrello.Payments;

            selectedPaymentId = 0;
            selectedShipmentId = 0;
            map: any;
            selectInfoWindow: any;
            locations = new Array<any>();

            footerData: any = shoppingCartData.footerData;
            headerData: any = header;

            userLogin = UserLogin;
            lang: string = this.languageService.getLongLang();
            private isUserAuthenticated: boolean;
            company: Company = new Company();
            authentication = this.authService.GetData();
            private userId = this.authService.GetUserId();
            cartId: number = 0;
            voucherCode: string = "";
            isVoucherValid: boolean = false;
            isVoucherInvalid: boolean = false;
            isVoucherApplied: boolean = false;
            hasPickUpActive: boolean = false;
            hasShipmentActive: boolean = false;
            hasDeliveryActive: boolean = false;
            private seoInfo: SeoViewModel = shoppingCartData.SeoInformation;
            private disableModalCartButtons: boolean = false;
            private spinnerCart: boolean = false;
            private idOfProduct: any;
            private breadcrumbs: Breadcrumbs[] = shoppingCartData.BreadcrumbsInfo;
            private isCompletedRegistration: any;
            private userData: any;
            private showProceedBtn: boolean = true;
            public parentWidgetData: string = shoppingCartData.CanvasInfo;
            mapZoom: number = shoppingCartData.MapZoom ;
            private clickedProductId: number = 0;
            private selectedProduct: any;
            public selectedTipoSpedizione: string = "";
            trasportoLabel: string = "";
            ritiroLabel: string = "";
            consegnaLabel: string = "";
            public TipiSpedizione: any[];
            subManager = new Subscription();
            countInitMap: number = 0;
            cartStep1: boolean = true;
            cartStep2: boolean = false;

            ngOnInit() {

                this.trasportoLabel = this.getLabel('tipoTrasporto_shipment')
                this.ritiroLabel = this.getLabel('tipoTrasporto_pickup')
                this.consegnaLabel = this.getLabel('tipoTrasporto_delivery')
                this.TipiSpedizione = [{
                    valore: this.trasportoLabel,
                    chiave: "S",
                    isVisible: true
                }, {
                    valore: this.ritiroLabel,
                    chiave: "P",
                    isVisible: true
                }, {
                    valore: this.consegnaLabel,
                    chiave: "D",
                    isVisible: true
                }];

                setTimeout(x => this.breadcrumbsService.setBreadcrumbs(this.breadcrumbs), 1);
                if (shoppingCartData.UserData != null) {
                    this.isCompletedRegistration = shoppingCartData.UserData.IsCompletedRegistration;
                    this.userData = shoppingCartData.UserData;
                }

                if (this.carrello.Products.length == 0) {
                    this.router.navigate(this.routesService.getRoutePath('EMPTY CART PAGE'));
                }
                else {
                    this.shoppingCartService.updateCart(this.carrello);
                    let userData = this.authService.GetData();
                    this.isUserAuthenticated = userData.isAuthenticated;
                    this.carrello.Payments = this.carrello.Payments.sort((a, b) => a.OrderSort - b.OrderSort)
                    for (let payment of this.carrello.Payments) {
                        if (payment.Selected == true) {
                            this.selectedPaymentId = payment.Id;
                            break;
                        }
                    }
                    this.hasPickUpActive = this.carrello.Shipments.sort((a, b) => a.Sort - b.Sort).filter((x: any) => x.TipoTrasporto == 'P').length > 0 ? true : false;
                    this.hasShipmentActive = this.carrello.Shipments.sort((a, b) => a.Sort - b.Sort).filter((x: any) => x.TipoTrasporto == 'S').length > 0 ? true : false;
                    this.hasDeliveryActive = this.carrello.Shipments.sort((a, b) => a.Sort - b.Sort).filter((x: any) => x.TipoTrasporto == 'D').length > 0 ? true : false;
                    this.checkTipoSpedizione();
                    this.carrello.Shipments.sort((a, b) => a.Sort - b.Sort).filter((x: any) => x.TipoTrasporto == 'P').forEach(element => {
                        var item = [element.Name, parseFloat(element.Latitudine), parseFloat(element.Longitudine), element.Id];
                        this.locations.push(item)
                    });



                    // for (let shipment of this.carrello.Shipments) {
                    //     if (shipment.Selected == true) {
                    //         // console.log("selectedShipmentId = "+shipment.Id)
                    //         this.selectedShipmentId = shipment.Id;
                    //         break;
                    //     }
                    // }
                }

                if (this.userData != undefined && this.userData != null) {
                    if (this.userData.Id_User_Group != 4) {
                        if ((this.userData.CodiceDestinatarioSDL == "" || this.userData.CodiceDestinatarioSDL == "0000000" || this.userData.CodiceDestinatarioSDL == undefined) && (this.userData.PecEmail == "" || this.userData.PecEmail == undefined)) {
                            this.showProceedBtn = false;
                        }
                    }
                }

                if (isChangeShipment) {
                    this.cartStep1 = false;
                    this.cartStep2 = true;
                }
            }
            scroll(id: any) {
                let el = document.getElementById(id);
                if(el!=null)
                {
                    el.scrollIntoView();
                }
            }
            gotoToStep1Cart() {
                this.cartStep1 = true;
                this.cartStep2 = false;
            }

            gotoToStep2Cart() {
                this.cartStep1 = false;
                this.cartStep2 = true;
            }

            changeTipoSpedizioneValue(valore) {
                if (this.selectedTipoSpedizione == valore) {
                    return;
                }
                this.selectedTipoSpedizione = valore;
                if (valore == 'P') {
                    this.initMap(this)
                }
                this.checkTipoSpedizione(true);
            }
            checkTipoSpedizione(isUpdate = false, isRemovingCart = false) {
                if (this.carrello.Products.length == 0) {
                    this.router.navigate(this.routesService.getRoutePath('EMPTY CART PAGE'));
                }
                else {
                    var tipoSped = this.carrello.Products.filter((item, i, arr) => arr.findIndex((t) => t.TipoTrasporto === item.TipoTrasporto) === i);
                    var TipoTrasportoShipmentToFilter = "S";
                    if (tipoSped.length == 1) {
                        TipoTrasportoShipmentToFilter = tipoSped[0].TipoTrasporto;
                    }
                    if (this.selectedTipoSpedizione == "") {
                        this.selectedTipoSpedizione = TipoTrasportoShipmentToFilter;
                    }
                    var showAllType = true;
                    var haveRowTime = this.carrello.Products.filter(x => x.DeliveryTime != "");
                    if (haveRowTime.length > 0) {
                        showAllType = false;
                    }
                    //console.log("hasDeliveryActive = "+this.hasDeliveryActive)
                    //console.log("hasPickUpActive = "+this.hasPickUpActive)
                    //console.log("hasShipmentActive = "+this.hasShipmentActive)
                    this.TipiSpedizione.forEach((tipoSped: any) => {
                        tipoSped.isVisible = true;
                        if (showAllType == false && (tipoSped.chiave == "S")) {
                            tipoSped.isVisible = false;
                        }

                        if (this.hasDeliveryActive == false && (tipoSped.chiave == "D")) {
                            tipoSped.isVisible = false;
                        }
                        if (this.hasPickUpActive == false && (tipoSped.chiave == "P")) {
                            tipoSped.isVisible = false;
                        }
                        if (this.hasShipmentActive == false && (tipoSped.chiave == "S")) {
                            tipoSped.isVisible = false;
                        }

                    })

                    if (isUpdate) {
                        this.shipmentToShow = this.carrello.Shipments.sort((a, b) => a.Sort - b.Sort).filter((x: any) => x.TipoTrasporto == this.selectedTipoSpedizione && x.DefaultShipment == true);
                        this.selectRadioShipment(this.shipmentToShow[0].Id);
                    }
                    else {
                        this.shipmentToShow = this.carrello.Shipments.sort((a, b) => a.Sort - b.Sort).filter((x: any) => x.TipoTrasporto == this.selectedTipoSpedizione);
                        if (this.shipmentToShow.filter((x: any) => x.Selected == true).length > 0) {
                            this.selectedShipmentId = this.shipmentToShow.filter((x: any) => x.Selected == true)[0].Id;
                        }
                        else {
                            if (isRemovingCart) {

                                if (this.selectedShipmentId > 0) {
                                    var shipmentToSelect = this.shipmentToShow.filter((x: any) => x.Id == this.selectedShipmentId);
                                    if (shipmentToSelect.length > 0) {
                                        this.selectedShipmentId = 0;
                                        this.selectRadioShipment(shipmentToSelect[0].Id, false, true);
                                    }
                                    else {
                                        this.selectRadioShipment(this.shipmentToShow[0].Id, false, true);
                                    }
                                }
                                else {
                                    var shipentToSelect = this.shipmentToShow[0].Id;
                                    if (this.shipmentToShow.filter((x: any) => x.DefaultShipment == true).length > 0) {
                                        shipentToSelect = this.shipmentToShow[0].Id
                                    }
                                    this.selectRadioShipment(shipentToSelect, false, true);
                                }
                            }
                            else {
                                var shipentToSelect = this.shipmentToShow[0].Id;
                                if (this.shipmentToShow.filter((x: any) => x.DefaultShipment == true).length > 0) {
                                    shipentToSelect = this.shipmentToShow[0].Id
                                }
                                this.selectRadioShipment(this.shipmentToShow[0].Id);
                            }
                        }
                    }
                }

            }

            openCanvasEditor(product) {
                this.clickedProductId = product.Id;

                if (shoppingCartData.CanvasInfo.CanvasUrl) {
                    // we have a state id, because product is already edited, so we kept it's state id in a database
                    const isStateId = true;
                    const canvasConfigData = this.setCanvasConfig(product);
                    this.canvasService.openCanvasEditor(canvasConfigData, isStateId);
                }
            }

            setCanvasConfig(product) {
                const canvasConfigData = {
                    CanvasUrl: shoppingCartData.CanvasInfo.CanvasUrl,
                    TemplateImagesFolderPath: shoppingCartData.CanvasInfo.TemplateImagesFolderPath,
                    CustomerCanvasUserName: shoppingCartData.CanvasInfo.CustomerCanvasUserName,
                    CanvasStateId: product.CanvasStateId,
                    Watermark: shoppingCartData.CanvasInfo.WatermarkText,
                    CanvasApiKey: shoppingCartData.CanvasInfo.ApiKey
                };

                return canvasConfigData;
            }

            toShowCanvasButton() {
                let toShow = false;
                let isModuleActive = false;

                if (shoppingCartData.CanvasInfo && shoppingCartData.CanvasInfo.IsActiveCanvasModule) {
                    isModuleActive = shoppingCartData.CanvasInfo.IsActiveCanvasModule;
                }

                toShow = isModuleActive && this.isUserAuthenticated ? true : false;

                return toShow;
            }

            // customers canvas state module is active and current product has canvasStateId defined, then send a request to delete a state from customers canvas server
            removeCustomersCanvasState() {
                if (this.toShowCanvasButton() && this.selectedProduct.CanvasStateId) {
                    const canvasConfigData = this.setCanvasConfig(this.selectedProduct);

                    this.canvasService.deleteCustomerCanvasState(canvasConfigData)
                        .subscribe(x => x,
                            err => {
                                console.log(err);
                            });
                }
            }

            goRegistrationPage() {
                //-- If this parameter is inside of cookie, it means that user used quick registration feature
                let quickRegistration = this.cookie.get("IsQuickRegistered");

                if (quickRegistration && Boolean(quickRegistration)) {
                    let navigationExtras: NavigationExtras = {
                        queryParams: { 'quickRegistration': true }
                    };

                    let registerRoute = this.routesService.getRoutePath('REGISTRAZIONE_PAGE_FROM')[0];
                    registerRoute = registerRoute.replace(":pagefrom", "cart");
                    registerRoute += "?quickRegistration=true";

                    (window as any).open(registerRoute, "_self");
                    //this.router.navigate([registerRoute]);
                }
                else {
                    if (this.isCompletedRegistration == false) {
                        this.registerService.setFacebookLoginData(this.userData);

                        let registerRoute = this.routesService.getRoutePath('REGISTRAZIONE_PAGE_FROM')[0];
                        registerRoute = registerRoute.replace(":pagefrom", "cart");

                        this.router.navigate([registerRoute]);
                    }
                    else {
                        this.router.navigate(this.routesService.getRoutePath('REGISTRAZIONE'));
                    }
                }
            };

            goLoginPage() {
                let loginRoute = this.routesService.getRoutePath('LOGIN_PAGE_FROM')[0];
                loginRoute = loginRoute.replace(":pagefrom", "cart");

                this.router.navigate([loginRoute]);
            };

            goToConfirmPurchasePage() {
                if (this.selectedPaymentId == 0) {
                    this.bootboxService.i18nAlert("selectPayment", 'pagamento');
                }
                else if (this.selectedShipmentId == 0) {
                    this.bootboxService.i18nAlert("selectPayment", 'pagamento');
                }
                else {
                    //this.router.navigateByUrl(this.routesService.getRoutePath('ACQUISTO - CASSA'));
                    (window as any).open(this.routesService.getRoutePath('ACQUISTO - CASSA'), "_self");
                }
            }

            goToModifyProfile() {
                this.router.navigate(this.routesService.getRoutePath('AREA CLIENTI - DATI UTENTE - CAMBIO DATI PERSONALI'));
            }

            saveCart() {
                let saveCartSub = this.shoppingCartService.saveCart(this.userId, this.cartId, this.selectedPaymentId, this.selectedShipmentId).subscribe(result => {
                    //this.router.navigate(this.routesService.getRoutePath('ACQUISTO - CASSA'));
                    (window as any).open(this.routesService.getRoutePath('ACQUISTO - CASSA'), "_self");
                });

                this.subManager.add(saveCartSub);
            }

            selectRadioPayment(paymentId) {
                if (this.selectedPaymentId != paymentId) {
                    this.selectedPaymentId = paymentId;
                    this.setPayment(paymentId);
                }
            }

            setPayment(paymentId) {
                this.spinnerCart = true;
                let paymentSub = this.shoppingCartService.setPayment(paymentId).subscribe(result => {
                    this.bootboxService.i18nAlert("selectedPayment", 'pagamento');
                    this.shoppingCartService.updateCart(result);
                    this.carrello = this.shoppingCartService.getCart();
                    this.carrello.Payments = this.carrello.Payments.sort((a, b) => a.OrderSort - b.OrderSort)
                    this.spinnerCart = false;
                });

                this.subManager.add(paymentSub);
            }

            selectRadioShipment(shipmentId, isOnMap = false, isOnRemove = false) {
                if (this.selectedShipmentId != shipmentId) {
                    this.selectedShipmentId = shipmentId;
                    this.setShipment(shipmentId, isOnMap, isOnRemove);
                }
            }

            setShipment(shipmentId, isOnMap = false, isOnRemove = false) {
                this.spinnerCart = true;
                let shipmentSub = this.shoppingCartService.setShipment(shipmentId).subscribe(result => {
                    if (!isOnRemove) {
                        this.bootboxService.i18nAlert("selectedShipment", 'spedizione');
                    }
                    this.shoppingCartService.updateCart(result);
                    this.carrello = this.shoppingCartService.getCart();
                    if (!isOnMap) {
                        this.SelectValueMap(this);
                    }
                    this.checkTipoSpedizione();
                    this.spinnerCart = false;
                });

                this.subManager.add(shipmentSub);
            }

            removeFromCart() {
                this.disableModalCartButtons = true;
                this.spinnerCart = true;

                let removeCartSub = this.shoppingCartService.removeFromCart(this.idOfProduct).subscribe(result => {
                    this.shoppingCartService.updateCart(result);
                    this.carrello = this.shoppingCartService.getCart();
                    this.spinnerCart = false;
                    this.disableModalCartButtons = false;
                    this.removeCustomersCanvasState();
                    this.checkTipoSpedizione(false, true);
                    if (this.carrello.Products != null && this.carrello.Products.length == 0) {
                        this.router.navigate(this.routesService.getRoutePath('EMPTY CART PAGE'));
                    }
                });

                this.subManager.add(removeCartSub);
                this.hideModal();
            }

            showModal(product) {
                this.disableModalCartButtons = false;
                this.idOfProduct = product.Id;
                this.selectedProduct = product;

                $("#cartModal").modal("show");
            }

            hideModal() {
                $('#cartModal').modal('hide');
            }

            getLabel(label) {
                let message;
                let sub = this.translate.get(label, this.translate).subscribe((res: string) => {
                    message = res;
                });
                this.subManager.add(sub);
                return message;
            }

            ngAfterViewInit() {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }
                setTimeout(function () {
                    let altezza = $("#footer").outerHeight();
                    let margintop = parseInt($("#footer").css('margin-top'));
                    let paddingntop = parseInt($("#footer").css('padding-top'));
                    altezza += margintop;
                    altezza += paddingntop;

                    let altezza1 = $(".footerplus").outerHeight() || 0;
                    let margintop1 = parseInt($(".footerplus").css('margin-top')) || 0;
                    let paddingntop1 = parseInt($(".footerplus").css('padding-top')) || 0;
                    altezza += altezza1;
                    altezza += margintop1;
                    altezza += paddingntop1;

                    let altezzaHead = $(".header-body").outerHeight();
                    //console.log(".header-body = " + altezzaHead)

                    let margintopHead = parseInt($(".header-body").css('margin-bottom'));
                    let paddingntopHead = parseInt($(".header-body").css('padding-bottom'));
                    altezzaHead += margintopHead;
                    altezzaHead += paddingntopHead;

                    $("#resumeCartTotal").sticky({ topSpacing: altezzaHead, bottomSpacing: altezza });
                    $("#resumeCartTotal-sticky-wrapper").height(0);
                    this.pageIsInit = true;
                }, 1);
            }
            applyVoucher(coupon) {
                if (this.voucherCode != null && this.voucherCode.trim().length > 0) {
                    this.spinnerCart = true;
                    let voucherSub = this.shoppingCartService.applyVoucher(this.voucherCode).subscribe(result => {
                        if (result.CartID != null) {
                            this.shoppingCartService.updateCart(result);
                            this.carrello = this.shoppingCartService.getCart();
                            this.isVoucherValid = true;
                            this.isVoucherInvalid = false;
                            this.isVoucherApplied = true;
                            this.voucherCode = "";
                        }
                        else {
                            this.isVoucherValid = false;
                            this.isVoucherInvalid = true;
                        }
                        this.spinnerCart = false;

                    },
                        err => {
                            this.bootboxService.i18nAlert("errorMex");
                            this.spinnerCart = false;

                        });

                    this.subManager.add(voucherSub);
                }
            };
            setJobName(rowId, jobName) {
                if (jobName != "") {
                    let jobNameSub = this.shoppingCartService.setJobName(rowId, jobName).subscribe(result => {
                        if (result == false) {
                            this.bootboxService.i18nAlert("errorMex");
                        }
                    },
                        err => {
                            this.bootboxService.i18nAlert("errorMex");
                        });

                    this.subManager.add(jobNameSub);
                }
            }
            ngAfterViewChecked() {
                if (!this.isBrowser || this.pageIsInitAfter) {
                    return;
                }
                //-- Set title, setup google analytics and other libraries 
                this.scriptService.setGoogleScripts(this.seoInfo);
                //hiding of loading panel after we get all data we need
                this.routesService.hidePageLoader();
                setTimeout(function () { 
                    $('.popovers').popover(); 
                  }, 150);
                this.pageIsInitAfter = true;
                this.initMap(this)
            }

            initMap(those: any) {
                if (those.locations.length > 0 && those.locations != null) {
                    if (google == undefined || google == null || !google) {
                        if (those.countInitMap > 3) {
                            $("#map").hide();
                            if ($("#listOfShipments").hasClass("col-md-4")) {
                                $("#listOfShipments").removeClass("col-md-4");
                                $("#listOfShipments").addClass("col-md-12");
                            }
                            return;
                        }
                        those.countInitMap++;
                        those.initMap(those);
                    }
                    else {
                        if (those.locations[0][1] == "" || those.locations[0][1] == undefined || those.locations[0][1] == null || isNaN(those.locations[0][1])) {
                            if ($("#listOfShipments").hasClass("col-md-4")) {
                                $("#listOfShipments").removeClass("col-md-4");
                                $("#listOfShipments").addClass("col-md-12");
                            }
                            $("#map").hide();
                            return;
                        }
                        var pt = new google.maps.LatLng(those.locations[0][1], those.locations[0][2]);
                        var map = new google.maps.Map(document.getElementById('map'), {
                            zoom: those.mapZoom,
                            center: pt,
                            mapTypeId: google.maps.MapTypeId.ROADMAP
                        });
                        map.setCenter(pt);

                        those.map = map;

                        var infowindow = new google.maps.InfoWindow();

                        var marker, i;

                        for (i = 0; i < those.locations.length; i++) {
                            if (those.locations[i][1] == "" || those.locations[i][1] == undefined || those.locations[i][1] == null || isNaN(those.locations[i][1])) {
                                $("#map").hide();
                                if ($("#listOfShipments").hasClass("col-md-4")) {
                                    $("#listOfShipments").removeClass("col-md-4");
                                    $("#listOfShipments").addClass("col-md-12");
                                }
                                continue;
                            }
                            else if (those.locations[i][2] == "" || those.locations[i][2] == undefined || those.locations[i][2] == null || isNaN(those.locations[i][2])) {
                                $("#map").hide();
                                if ($("#listOfShipments").hasClass("col-md-4")) {
                                    $("#listOfShipments").removeClass("col-md-4");
                                    $("#listOfShipments").addClass("col-md-12");
                                }
                                continue;
                            }
                            marker = new google.maps.Marker({
                                position: new google.maps.LatLng(those.locations[i][1], those.locations[i][2]),
                                map: map
                            });
                            if (those.selectedShipmentId == those.locations[i][3]) {
                                infowindow.setContent(those.locations[i][0]);
                                infowindow.open(map, marker);
                            }
                            google.maps.event.addListener(marker, 'click', (function (marker, i) {

                                return function () {
                                    infowindow.setContent(those.locations[i][0]);
                                    infowindow.open(map, marker);
                                    those.selectRadioShipment(those.locations[i][3], true);
                                    those.scroll(those.locations[i][3]);
                                }

                            })(marker, i));
                        }
                        those.selectInfoWindow = infowindow;
                    }
                }
                else {
                    return;
                }
            }
            SelectValueMap(those: any) {
                if (those.locations.length > 0 && those.locations != null) {
                    if (google == undefined || google == null || !google) {
                        if (those.countInitMap > 3) {
                            $("#map").hide();
                            if ($("#listOfShipments").hasClass("col-md-4")) {
                                $("#listOfShipments").removeClass("col-md-4");
                                $("#listOfShipments").addClass("col-md-12");
                            }
                            return;
                        }
                        those.countInitMap++;
                        those.SelectValueMap(those);
                    }
                    else {

                        if (those.selectInfoWindow != "" && those.selectInfoWindow != undefined && those.selectInfoWindow != null) {
                            those.selectInfoWindow.close();
                            var infowindow = new google.maps.InfoWindow();
                            those.selectInfoWindow = infowindow;
                            var marker, i;
                            for (i = 0; i < those.locations.length; i++) {
                                if (those.locations[i][1] == "" || those.locations[i][1] == undefined || those.locations[i][1] == null || isNaN(those.locations[i][1])) {
                                    $("#map").hide();
                                    if ($("#listOfShipments").hasClass("col-md-4")) {
                                        $("#listOfShipments").removeClass("col-md-4");
                                        $("#listOfShipments").addClass("col-md-12");
                                    }
                                    continue;
                                }
                                else if (those.locations[i][2] == "" || those.locations[i][2] == undefined || those.locations[i][2] == null || isNaN(those.locations[i][2])) {
                                    $("#map").hide();
                                    if ($("#listOfShipments").hasClass("col-md-4")) {
                                        $("#listOfShipments").removeClass("col-md-4");
                                        $("#listOfShipments").addClass("col-md-12");
                                    }
                                    continue;
                                }
                                else {

                                    marker = new google.maps.Marker({
                                        position: new google.maps.LatLng(parseFloat(those.locations[i][1]), parseFloat(those.locations[i][2])),
                                        map: those.map
                                    });
                                    if (those.selectedShipmentId == those.locations[i][3]) {
                                        infowindow.setContent(those.locations[i][0]);
                                        infowindow.open(those.map, marker);
                                    }
                                    google.maps.event.addListener(marker, 'click', (function (marker, i) {

                                        return function () {
                                            infowindow.setContent(those.locations[i][0]);
                                            infowindow.open(those.map, marker);
                                            those.selectRadioShipment(those.locations[i][3], true);
                                            those.scroll(those.locations[i][3]);
                                        }

                                    })(marker, i));
                                }
                            }
                            those.selectInfoWindow = infowindow;
                        }
                    }
                }
                else {
                    return;
                }
            }

            ngOnDestroy() {
                //Called once, before the instance is destroyed.
                //Add 'implements OnDestroy' to the class.
                this.subManager.unsubscribe();
            }
        }

        return ChildComponent;
    }
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/components/inventory/shopping-cart/sys/cart.component.ts